export default {
  soldCountLabel: {
    id: 'product_card_sold_count_label',
    defaultMessage: '{bucket}+ sold in the last 30 days',
  },
} as const
